import React from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import { NavItem, NavLink } from 'reactstrap';
import Icon from '../common/containers/icon';
const MainMenuItem = _ref => {
  let _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? () => {} : _ref$onClick,
    _ref$href = _ref.href,
    href = _ref$href === void 0 ? '#' : _ref$href,
    _ref$glyph = _ref.glyph,
    glyph = _ref$glyph === void 0 ? '' : _ref$glyph,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {
      textAlign: 'center'
    } : _ref$style,
    title = _ref.title;
  return /*#__PURE__*/React.createElement(NavItem, {
    className: className.length > 0 ? kebabCase(className) : kebabCase("mdi-".concat(title)),
    style: style,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(NavLink, {
    href: href
  }, glyph.length > 0 ? /*#__PURE__*/React.createElement(Icon, {
    glyph: glyph
  }) : null, /*#__PURE__*/React.createElement("br", null), title));
};
MainMenuItem.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  glyph: PropTypes.string,
  href: PropTypes.string,
  style: PropTypes.shape({}),
  onClick: PropTypes.func
};
export default MainMenuItem;